import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';

const HomePage = ({ onContactClick }) => {
  return (
    <>
      <Hero onContactClick={onContactClick} />
      <About />
    </>
  );
};

export default HomePage;
